// TODO JRU je potřeba na webpacku nastavit webpack-rollup-loader viz https://webpack.js.org/guides/tree-shaking/
// export { default as InlineComponents } from './InlineComponents';
export { default as WebComponent } from './WebComponent';
export { default as connectWebActions } from './connectWebActions';
export {
  connectWebComponents,
  disposeInnerComponents,
  decorateInnerElements,
} from './decorate';

// export { default as ElementPortal } from './ElementPortal';
// export { default as LazilyLoad, importLazy } from './LazilyLoad';
// export { default as inlineHOC } from './inlineHOC';
// export { default as reducer } from './reducer';
// export * from './decorate';



// WEBPACK FOOTER //
// ./node_modules/fg-frontend/src/webComponents/index.js